var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46.2 44.8",
    enableBackground: "new 0 0 46.2 44.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M25.1,24.3c-0.4,0-0.7-0.1-0.9-0.4c-0.3-0.3-0.4-0.6-0.4-1V6.3c0-3.5,2.8-6.3,6.3-6.3h9.7 c3.5,0,6.3,2.8,6.3,6.3v7.9c0,3.5-2.8,6.3-6.3,6.3h-8.7c-1.3,0-2.5,0.6-3.3,1.5l-1.5,1.8C25.9,24.1,25.6,24.3,25.1,24.3z M30.1,2 c-2.4,0-4.3,1.9-4.3,4.3v14.9l0.5-0.5c1.2-1.4,3-2.2,4.8-2.2h8.7c2.4,0,4.3-1.9,4.3-4.3V6.3c0-2.4-1.9-4.3-4.3-4.3H30.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M26.7,44.9H1c-0.6,0-1-0.4-1-1v-5.8c0-1.8,0.9-3.5,2.3-4.4c1.5-0.9,3-1.6,4.6-2.2c1.3-0.4,1.9,0.7,2.2,1.3 c0.4,0.7,0.9,1.6,2.2,2.2c0.5,0.2,0.7,0.8,0.5,1.3c-0.2,0.5-0.8,0.7-1.3,0.5c-1.9-0.8-2.6-2.2-3.1-3c0-0.1-0.1-0.2-0.2-0.3 c-1.3,0.5-2.6,1.1-3.8,1.9C2.5,35.9,2,37,2,38.1v4.8h23.7v-4.7c0-1.2-0.6-2.3-1.5-2.8c-1-0.6-2.6-1.3-4.5-1.9 c-0.3,1-0.9,2.6-3.3,3.3c-0.5,0.1-1.1-0.2-1.2-0.7c-0.1-0.5,0.2-1.1,0.7-1.2c1.5-0.4,1.8-1.4,2-2.2c0.1-0.5,0.3-1,0.8-1.3 c0.3-0.2,0.6-0.2,0.9-0.1C22,32,24,33,25.2,33.7c1.5,0.9,2.5,2.6,2.5,4.5v5.7C27.7,44.4,27.3,44.9,26.7,44.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M13.4,29.6c-3.7,0-6.6-3.6-6.6-8.1c0-1.7,0.1-3.9,0.6-5.2c0.8-2.1,3.1-3.3,6.1-3.3c3.2,0,5.4,1.2,6.1,3.4 c0.5,1.3,0.5,3.8,0.5,5.2C20,26,17.1,29.6,13.4,29.6z M13.4,15c-0.8,0-3.5,0.1-4.2,2.1c-0.4,1.1-0.4,3.7-0.4,4.5 c0,3.4,2.1,6.1,4.6,6.1c2.6,0,4.6-2.7,4.6-6.1c0-2.1-0.2-3.8-0.4-4.5C17,15.2,14.7,15,13.4,15z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M13.5,44.3c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v4C14.5,43.9,14,44.3,13.5,44.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M30.1,11.8c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3S30.8,11.8,30.1,11.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M35.1,11.8c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3S35.8,11.8,35.1,11.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M40.1,11.8c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3S40.8,11.8,40.1,11.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.ed97138fc7f8e573d0d895c7cacd3d74.svg";
export { ForwardRef as ReactComponent };